import { z } from 'zod';
export const AiCoachFaq = z.object({
  answer: z.string(),
  question: z.string()
});
export const AiCoachContent = z.object({
  faqs: z.array(AiCoachFaq),
  realLifeExample: z.string(),
  simpleExplanation: z.string(),
  videoSummary: z.string()
});